// Simple helpers for state-aware routing (e.g. /US/loanInformation).
// This mirrors the lightweight logic used in the newer frontend_v2.

const STATE_STORAGE_KEY = 'tenant_state';
const STATE_CODE_REGEX = /^[A-Z]{2}$/;

const normalizeStateId = (value) => {
  if (value === undefined || value === null) return null;
  const normalized = String(value).trim().toUpperCase();
  return STATE_CODE_REGEX.test(normalized) ? normalized : null;
};

export const stripStatePrefix = (pathname) => {
  if (!pathname) return '/';
  const match = pathname.match(/^\/[a-zA-Z]{2}(?=\/|$)/);
  if (!match) return pathname;
  const remainder = pathname.slice(match[0].length);
  const normalized = remainder.startsWith('/')
    ? remainder
    : remainder
    ? `/${remainder}`
    : '';
  return normalized || '/';
};

export const getCurrentStateId = () => {
  if (typeof window === 'undefined') return null;

  const match = window.location.pathname.match(/^\/([a-zA-Z]{2})(?:\/|$)/);
  if (match) {
    const code = normalizeStateId(match[1]);
    if (code) {
      try {
        sessionStorage.setItem(STATE_STORAGE_KEY, code);
      } catch {
        // ignore storage failures in non-browser environments
      }
      return code;
    }
  }

  try {
    const stored = sessionStorage.getItem(STATE_STORAGE_KEY);
    const normalized = normalizeStateId(stored);
    if (!normalized && stored) {
      sessionStorage.removeItem(STATE_STORAGE_KEY);
    }
    return normalized;
  } catch {
    return null;
  }
};

export const persistStateId = (stateId) => {
  if (typeof window === 'undefined') return;
  const normalized = normalizeStateId(stateId);
  if (!normalized) return;
  try {
    sessionStorage.setItem(STATE_STORAGE_KEY, normalized);
  } catch {
    // ignore storage failures
  }
};

export const buildPathForState = (stateId, path = '/') => {
  const normalizedState = normalizeStateId(stateId);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (!normalizedState) {
    return normalizedPath;
  }
  return `/${normalizedState}${normalizedPath}`.replace(/\/{2,}/g, '/');
};

export const buildStateAwarePath = (path = '/') => {
  const stateId = getCurrentStateId();
  return buildPathForState(stateId, path);
};

